import React, { Fragment, useEffect, useState } from "react";
import "../../../styles/components/einleitstelleDaten.css";
import { useForm } from "../../../utils/FormUtils";

function MindestanforderungDaten({ formFactory, currentAnhang, mindestanforderungen, onMindestanforderungenUpdate }) {
    const [expandedMindestanforderungIndex, setExpandeMindestanforderungIndex] = useState(0);
    const { setValues } = useForm({ initialValues: mindestanforderungen, readonly: true });

    useEffect(() => {
        if (Array.isArray(mindestanforderungen)) {
            if (mindestanforderungen.length < expandedMindestanforderungIndex) {
                setExpandeMindestanforderungIndex(0);
                setValues(mindestanforderungen[0]);
            } else if (expandedMindestanforderungIndex >= 0) {
                setValues(mindestanforderungen[expandedMindestanforderungIndex]);
            }
        }
    }, [mindestanforderungen, expandedMindestanforderungIndex, setValues]);

    function renderParameterwerteManuell() {
        return (
            <Fragment>
                {formFactory.renderNumberInput("anhang.csb", "anhang.csb", "CSB", false)}
                {formFactory.renderNumberInput("anhang.pges", "anhang.pges", "PGES", false)}
                {formFactory.renderNumberInput("anhang.nges", "anhang.nges", "NGES", false)}
                {formFactory.renderNumberInput("anhang.nh4n", "anhang.nh4n", "NH4N", false)}
                {formFactory.renderNumberInput("anhang.bsb5", "anhang.bsb5", "BSB5", false)}
                {formFactory.renderNumberInput("anhang.aox", "anhang.aox", "AOX", false)}
                {formFactory.renderNumberInput("anhang.hg", "anhang.hg", "HG", false)}
                {formFactory.renderNumberInput("anhang.cd", "anhang.cd", "CD", false)}
                {formFactory.renderNumberInput("anhang.cr", "anhang.cr", "CR", false)}
                {formFactory.renderNumberInput("anhang.ni", "anhang.ni", "NI", false)}
                {formFactory.renderNumberInput("anhang.pb", "anhang.pb", "PB", false)}
                {formFactory.renderNumberInput("anhang.cu", "anhang.cu", "CU", false)}
                {formFactory.renderNumberInput("anhang.gei", "anhang.gei", "GEI", false)}
            </Fragment>
        );
    }

    function renderParameterwerte() {
        return (
            <Fragment>
                {formFactory.renderNumberInput("anhang.anhangAbwasserverordnung.csb", "anhang.anhangAbwasserverordnung.csb", "CSB", true)}
                {formFactory.renderNumberInput("anhang.anhangAbwasserverordnung.pges", "anhang.anhangAbwasserverordnung.pges", "PGES", true)}
                {formFactory.renderNumberInput("anhang.anhangAbwasserverordnung.nges", "anhang.anhangAbwasserverordnung.nges", "NGES", true)}
                {formFactory.renderNumberInput("anhang.anhangAbwasserverordnung.nh4n", "anhang.anhangAbwasserverordnung.nh4n", "NH4N", true)}
                {formFactory.renderNumberInput("anhang.anhangAbwasserverordnung.bsb5", "anhang.anhangAbwasserverordnung.bsb5", "BSB5", true)}
                {formFactory.renderNumberInput("anhang.anhangAbwasserverordnung.aox", "anhang.anhangAbwasserverordnung.aox", "AOX", true)}
                {formFactory.renderNumberInput("anhang.anhangAbwasserverordnung.hg", "anhang.anhangAbwasserverordnung.hg", "HG", true)}
                {formFactory.renderNumberInput("anhang.anhangAbwasserverordnung.cd", "anhang.anhangAbwasserverordnung.cd", "CD", true)}
                {formFactory.renderNumberInput("anhang.anhangAbwasserverordnung.cr", "anhang.anhangAbwasserverordnung.cr", "CR", true)}
                {formFactory.renderNumberInput("anhang.anhangAbwasserverordnung.ni", "anhang.anhangAbwasserverordnung.ni", "NI", true)}
                {formFactory.renderNumberInput("anhang.anhangAbwasserverordnung.pb", "anhang.anhangAbwasserverordnung.pb", "PB", true)}
                {formFactory.renderNumberInput("anhang.anhangAbwasserverordnung.cu", "anhang.anhangAbwasserverordnung.cu", "CU", true)}
                {formFactory.renderNumberInput("anhang.anhangAbwasserverordnung.gei", "anhang.anhangAbwasserverordnung.gei", "GEI", true)}
            </Fragment>
        );
    }

    return (
        <div className="gridl tabsheet-content-margin" style={{ gridTemplateColumns: "repeat(4, 1fr)", justifyContent: "center" }}>
            {currentAnhang && currentAnhang.anhangNr === "A00" && renderParameterwerteManuell()}
            {currentAnhang && currentAnhang.anhangNr !== "A00" && renderParameterwerte()}
        </div>
    );
}

export default MindestanforderungDaten;
